<div class="ant-form-item-control" [ngClass]="controlClassMap">
  <span class="ant-form-item-children">
    <ng-content></ng-content>
  </span>
  <ng-content select="dw-form-explain"></ng-content>
</div>